import { Text } from '@mantine/core';

import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

import type { ResponseProjectBlock } from '../../../../../../../../../shared/entities/ResponseProjectBlock';

interface BlockContentProps {
  block: ResponseProjectBlock;
}

export function BlockContent({ block }: BlockContentProps) {
  if (!block.content) {
    return null;
  }

  return (
    <Text
      c="gray.9"
      size="sm"
      fw={400}
      sx={{
        '& > p:first-of-type': { marginTop: '0' },
        '& > p:last-of-type': { marginBottom: '0' },
      }}
    >
      <Markdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
        {block.content}
      </Markdown>
    </Text>
  );
}
